import AddCircleIcon from '@mui/icons-material/AddCircle';
import {
  Avatar,
  Box,
  Button,
  Card,
  Grid,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Typography,
} from "@mui/material";
import * as React from "react";
import { useEffect, useState } from 'react';
import Image from 'react-bootstrap/Image';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import socialIcons from '../../src/assets/images/icons/instagram.svg';
import influencerProfImgs from '../../src/assets/images/userProf.png';
import CommonModel from '../components/dialog/Common';
import { usePushNotificationMutation } from "../redux/firebaseApi";
import { capitalizeWords, formatPrice, getCompanyid, getFormatedDate, getUserType } from '../utils/common';
import { COMPANY, getFixedValue, getFixedValueToNonDecimal, InfluencerListAi, RESPONSIVE_CARD_FONT_SIZE, trunCateString } from '../utils/constant';
import { getAllBrandForDropDown } from './brands/action';
import { getAllCampaignInfluencerStatus, getMyCampaigns } from './campaigns/action';
import { updateCampaign } from './campaigns/campaignSlice';
import { updateUser } from './users/userSlice';
import Tooltip from '@mui/material/Tooltip';
import { Link } from 'react-router-dom';
import arrow from '../assets/images/icons/arrow-left.svg'
import moment from 'moment';
import { visuallyHidden } from "@mui/utils";
import discoverBg from '../assets/images/dashboardDiscoveryBgImg.png'
import ruppeeIcon from '../assets/images/icons/greenRupee.png'
import lockIcon from '../assets/images/icons/Lock.png'
import moneyPotIcon from '../assets/images/icons/moneyPot.png'
import creditCardIcon from '../assets/images/icons/cardCredit.png'
import { getWalletDetails } from './wallet/action';
import addMoneyWalletBg from '../assets/images/icons/AddMoneyDashBoardBackground.png'
import AddMoney from '../components/dialog/AddMoney';
import blueUpwardArrow from '../assets/images/icons/blueUpwardArrow.svg'
import userIcon from '../assets/images/icons/dashboardUser.svg'
import userEngement from '../assets/images/icons/dashboardEne.svg'
import userHeart from '../assets/images/icons/dashboardHeart.svg'
import Rocket from '../assets/images/icons/Rocket3.svg'

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 3,
    slidesToSlide: 3,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1
  }
};
const Dashboard = () => {
  const [pushNotification] = usePushNotificationMutation();
  const [active, setActive] = useState(1);
  const {
    myCampaigns, allStatusCount, sort_key
  } = useSelector((state) => state.campaignSlice);
  const { walletDetails } = useSelector((state) => state.walletSlice);
  const {isScreenZoomed} = useSelector(state=>state.commonSlice);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [order, setOrder] = React.useState("asc");
  const [influencerStatus, setInfluencerStatus] = useState([]);
  const [modelNewOpen, setModelOpen] = useState(false);
  const [paymentModalOpen, setAddPaymentOpen] = useState(false);
  const { modelOpen, brandCount } = useSelector((state) => state.userSlice)
  const { brandsDropdown } = useSelector((state) => state.brandSlice);
  const getInfluencerStatus = async () => {
    const result = await getAllCampaignInfluencerStatus();
    setInfluencerStatus(result)
  }

  useEffect(() => {
    const token = localStorage.getItem("notificationToken");
    getInfluencerStatus();
    if (token) {
      const payload = {
        token,
        title: "Welcome",
        message: "This is demo notification",
      };
      pushNotification(payload)
        .then((res) => {
        })
        .catch((error) => {
        });
    }
    dispatch(updateCampaign({ page: 0, limit: 5, myCampaignsFilters: {} }));
    dispatch(getMyCampaigns());
    if (getUserType() === COMPANY) {
      dispatch(getAllBrandForDropDown(getCompanyid()));
    }
    dispatch(getWalletDetails());
    return () => dispatch(updateUser({ modelOpen: false }));
  }, []);
  function EnhancedTableHead(props) {
    const { order, orderBy } = props;
    const headCells = [
      {
        id: "name",
        numeric: false,
        disablePadding: true,
        label: "Name",
        type: "",
      },
      {
        id: "brand",
        numeric: false,
        disablePadding: true,
        label: "Brand",
        type: "",
      },
      {
        id: "type",
        numeric: false,
        disablePadding: true,
        label: "Type",
        type: "",
      },
      {
        id: "publishDuration",
        numeric: false,
        disablePadding: true,
        label: "Duration",
        type: "",
      },
      {
        id: "status",
        numeric: false,
        disablePadding: true,
        label: "Status",
        type: "",
      },
      {
        id: "action",
        numeric: false,
        disablePadding: true,
        label: "Action",
        type: "",
      },
    ];
    return (
      <TableHead className="hideActionSort">
        <TableRow sx={{ background: '#DBECFF !important', height: "50px", "& th": { backgroundColor: "inherit !important" }, }}>
          {headCells.map((headCell) => {
            return (
              <TableCell
                key={headCell?.id}
                align={"left"}
                padding={headCell.disablePadding ? "none" : "normal"}
                sortDirection={orderBy === headCell.id ? order : false}>
                <TableSortLabel
                  active={orderBy === headCell.id}
                  direction={orderBy === headCell.id ? order : "asc"}
                  IconComponent={() => null}>
                  {headCell.label}
                  {orderBy === headCell.id ? (
                    <Box component="span" sx={visuallyHidden}>
                      {order === "desc"
                        ? "sorted descending"
                        : "sorted ascending"}
                    </Box>
                  ) : null}
                </TableSortLabel>
              </TableCell>
            );
          })}
        </TableRow>
      </TableHead>
    );
  }
  const getStatusCss = (status) => {
    let cssObj = {};
    switch (status) {
      case "Negotiation":
        cssObj = {
          color: '#FE5D26', background: '#FFE4DB'
        }
        break;
      case "Script Upload":
        cssObj = {
          color: '#F72585', background: '#FEDBEB'
        }
        break;
      case "Link Publish":
        cssObj = {
          color: '#7209B7', background: '#EFD9FD'
        }
        break;
      case "Content Upload":
        cssObj = {
          color: '#0077FF', background: '#DBECFF'
        }
        break;
      case "Product Shipped ":
        cssObj = {
          color: '#22C55E', background: '#F0FDF4'
        }
        break;
      default:
        cssObj = {
          color: '#22C55E', background: '#F0FDF4'
        }
        break;
    }
    return cssObj;
  }
  const IsCompany = getUserType() === COMPANY;
  const showCampaignStatusCount = (allStatusCount["liveCount"] > 0 || allStatusCount["completedCount"] > 0 || allStatusCount["draftCount"] > 0);

  return (
    <>
      <AddMoney open={paymentModalOpen} setOpen={setAddPaymentOpen} />
      {IsCompany ? (<Grid
        container
        spacing={2}
        sx={{ height: isScreenZoomed ? '100%' : '90vh', p: 2,scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    }, }}
      >
        <Grid item xs={6}>
          <Grid container spacing={2} >
            <Grid item xs={6}>
              <Box sx={{
                boxShadow: '0px 0px 24px 0px rgba(0, 0, 0, 0.10)', borderRadius: '10px',
                height: '200px',
                width: '100%', padding: '16px',
              }}>
                <Stack direction="column" justifyContent="space-between" height={"100%"}>
                  <Stack direction={"row"} justifyContent="space-between" alignItems="center">
                    <Typography fontSize={16} fontWeight={500} color={"#000000"}>Total Campaigns</Typography>
                    <Link style={{ textDecoration: 'none' }} to={IsCompany ? "/my-campaigns" : "/campaign-management"}>
                      <Typography fontSize={16} fontWeight={400} color={"var(--color-blue)"} sx={{ textDecoration: 'none' }}>See All</Typography>
                    </Link>
                  </Stack>
                  <Stack sx={{ border: showCampaignStatusCount ? '1px solid #F0F0F0' : '0px', borderRadius: '10px', padding: '10px', height: '67px' }} direction="row" justifyContent="space-evenly" alignItems="center">
                    {showCampaignStatusCount ? <><Box sx={{ textAlign: 'center' }}>
                      <Typography fontSize={20} fontWeight={700}>{allStatusCount["liveCount"] || 0}</Typography>
                      <Typography fontSize={14} fontWeight={500} color="#166534">Live</Typography>
                    </Box><Box sx={{ width: '1px', height: '47px', background: '#CCCBCB' }} /><Box sx={{ textAlign: 'center' }}>
                        <Typography fontSize={20} fontWeight={700}>{allStatusCount["completedCount"] || 0}</Typography>
                        <Typography fontSize={14} fontWeight={500} color="#22C55E">Completed</Typography>
                      </Box><Box sx={{ width: '1px', height: '47px', background: '#CCCBCB' }} /><Box sx={{ textAlign: 'center' }}>
                        <Typography fontSize={20} fontWeight={700}>{allStatusCount["draftCount"] || 0}</Typography>
                        <Typography fontSize={14} fontWeight={500} color="#726C6C">Draft</Typography>
                      </Box></> : <Typography fontSize={14} fontWeight={400} color="#726C6C">There is no campaign, first create a campaign. </Typography>}
                  </Stack>
                  <Link to={"/campaign/type"}>
                    <Button
                      sx={{
                        borderRadius: '10px', position: 'relative', background: 'linear-gradient(90deg,rgba(255, 204, 112, 1) 0%, rgba(200, 80, 192, 1) 50%, rgba(65, 88, 208, 1) 100%)', padding: '2px', overflow: 'hidden', width: '100%'
                      }}
                    >
                      <Typography sx={{
                        width: '100%', padding: '10px 20px', background: 'white', borderRadius: '8px', color: '#000000', fontWeight: '500', fontSize: '16px', height: '43px', "&:hover": {
                          background: 'transparent', color: 'white', "img": {
                            filter: 'brightness(100)', mixBlendMode: 'screen'
                          }
                        }
                      }}>
                        Create New Campaign <img src={arrow} alt="" style={{ width: '20px', height: '20px', rotate: '180deg' }} />
                      </Typography>
                    </Button>
                  </Link>
                </Stack>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box sx={{
                boxShadow: '0px 0px 24px 0px rgba(0, 0, 0, 0.10)', borderRadius: '10px',
                height: '200px',
                width: '100%', padding: '16px',
              }}>
                <Stack direction="column" justifyContent="space-between" height={"100%"}>
                  <Stack direction={"row"} justifyContent="space-between" alignItems="center">
                    <Typography fontSize={16} fontWeight={500} color={"#000000"}>{IsCompany ? "Brands" : "Companies"}</Typography>
                    <Link style={{ textDecoration: 'none' }} to={IsCompany ? "/company-brands" : "/companies"}>
                      <Typography fontSize={16} fontWeight={400} color={"var(--color-blue)"} sx={{ textDecoration: 'none' }}>See All</Typography>
                    </Link>
                  </Stack>
                  <Stack direction="row" justifyContent="flex-start" gap={isScreenZoomed ? 1.5 : 1} overflow={"hidden"}>
                    {brandsDropdown.length > 0 ? brandsDropdown?.slice(0, isScreenZoomed ? 7 : 8)?.map((item) => (
                      <Avatar src={item.brandImage} sx={{ height:isScreenZoomed ? '34px' : '43px', width: isScreenZoomed ? '34px' : '43px' }} />
                    )) : <Typography fontSize={14} fontWeight={400} color="#726C6C" textAlign="center" width="100%">Before creating a campaign first add your brand.</Typography>}
                  </Stack>
                  <Link to={IsCompany ? "/company-brands" : "/company/add"}>
                    <Button
                      sx={{
                        borderRadius: '10px', position: 'relative', background: 'linear-gradient(90deg,rgba(255, 204, 112, 1) 0%, rgba(200, 80, 192, 1) 50%, rgba(65, 88, 208, 1) 100%)', padding: '2px', overflow: 'hidden', width: '100%'
                      }}
                    >
                      <Typography sx={{
                        width: '100%', padding: '10px 20px', background: 'white', borderRadius: '8px', color: '#000000', fontWeight: '500', fontSize: '16px', height: '43px', "&:hover": {
                          background: 'transparent', color: 'white', "img": {
                            filter: 'brightness(100)', mixBlendMode: 'screen'
                          }
                        }
                      }}>
                        Add New {IsCompany ? "Brand" : "Company"} <img src={arrow} alt="" style={{ width: '20px', height: '20px', rotate: '180deg' }} />
                      </Typography>
                    </Button>
                  </Link>
                </Stack>
              </Box>
            </Grid>
            {myCampaigns.length > 0 ? <><MyCampaignListingDiv isScreenZoomed={isScreenZoomed} EnhancedTableHead={EnhancedTableHead} navigate={navigate} myCampaigns={myCampaigns} order={order} sort_key={sort_key} /><SearchInfluencerDiv isScreenZoomed={isScreenZoomed} navigate={navigate} /></> : <>
              <SearchInfluencerDiv isScreenZoomed={isScreenZoomed} navigate={navigate} /><MyCampaignListingDiv isScreenZoomed={isScreenZoomed} EnhancedTableHead={EnhancedTableHead} navigate={navigate} myCampaigns={myCampaigns} order={order} sort_key={sort_key} />
            </>}
          </Grid>
        </Grid>
        <Grid item xs={6}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Box sx={{
                boxShadow: '0px 0px 24px 0px rgba(0, 0, 0, 0.10)', borderRadius: '10px',
                height: '404px',
                width: '100%', padding: '16px',
              }}>
                <Stack direction={"row"} justifyContent="space-between" alignItems="top" pb={1.5}>
                  <Box>
                    <Stack direction="row" justifyContent="flex-start" gap={1}>
                      <Typography fontSize={16} fontWeight={500} color={"#000000"} pb={0.5}>Top Trending Profiles</Typography>
                      <Typography sx={{
                        background: "linear-gradient(90deg, #FFCC70 0%, #C850C0 50%, #4158D0 100%)",
                        backgroundClip: "text",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        fontSize: '16px', fontWeight: 500,
                      }}>
                        (Powered by AI✨)
                      </Typography>
                    </Stack>
                    <Typography fontSize={12} fontWeight={400} color={"#726C6C"}>Here are some profiles we've recommended based on your search.</Typography>
                  </Box>
                  <Link style={{ textDecoration: 'none' }} to={"/discover-influencers"}>
                    <Typography fontSize={16} fontWeight={400} color={"var(--color-blue)"} sx={{ textDecoration: 'none' }}>See All</Typography>
                  </Link>
                </Stack>
                <Stack direction="row" justifyContent="flex-start" gap={2} sx={{
                  touchAction: 'pan-x', overflowX: 'scroll', overflowY: 'hidden', width: '100%', flexWrap: 'nowrap', scrollbarWidth: 'none',
                  '&::-webkit-scrollbar': {
                    display: 'none',
                  },
                }} >
                  {InfluencerListAi?.map((item)=>(<Box key={item.id} sx={{ height: '320px', width: '218px', minWidth: '218px', padding: '1px', borderRadius: '12px', background: "linear-gradient(90deg, #FFCC70 0%, #C850C0 50%, #4158D0 100%)", }}>
                    <Stack direction={"column"} justifyContent="space-around" sx={{ height: '100%', width: '100%', padding: '10px', borderRadius: '10px', background: 'white', }}>
                      <Stack direction="column" gap={0.5} justifyContent="center" sx={{ border: '0px solid red', width: '100%', alignItems: 'center', }}>
                        <Avatar src={item?.picture} sx={{ height: '85px', width: '85px' }} />
                        <Typography fontSize={16} fontWeight={500} color="black">{trunCateString((item?.name||'Unknown'),20)}</Typography>
                        <Typography fontSize={12} fontWeight={400} color="var(--color-blue)">@{item.instagram}</Typography>
                      </Stack>
                      <Stack direction="row" justifyContent="space-around" sx={{ border: '0px solid red', }}>
                        <Box sx={{ textAlign: 'center' }}>
                          <img src={userIcon} alt="" />
                          <Typography fontSize={12} fontWeight={600} color="black">{getFixedValueToNonDecimal(item.followers)}</Typography>
                          <Typography fontSize={12} fontWeight={400} color="#726C6C">Followers</Typography>
                        </Box>
                        <Box sx={{ textAlign: 'center' }}>
                          <img src={userEngement} alt="" />
                          <Typography fontSize={12} fontWeight={600} color="black">{getFixedValue(item?.Engagement?.posts?.engagement_rate) || "N/A"}</Typography>
                          <Typography fontSize={12} fontWeight={400} color="#726C6C">Eng. Rate</Typography>
                        </Box>
                        <Box sx={{ textAlign: 'center' }}>
                          <img src={userHeart} alt="" />
                          <Typography fontSize={12} fontWeight={600} color="black">{getFixedValue(item?.Engagement?.posts?.avg_likes) || "N/A"}</Typography>
                          <Typography fontSize={12} fontWeight={400} color="#726C6C">Avg. Likes</Typography>
                        </Box>
                      </Stack>
                      <Button
                      onClick={()=>navigate(`/userManagement/details/${item.id}`)}
                        sx={{
                          borderRadius: '10px', position: 'relative', background: 'linear-gradient(90deg,rgba(255, 204, 112, 1) 0%, rgba(200, 80, 192, 1) 50%, rgba(65, 88, 208, 1) 100%)', padding: '2px', overflow: 'hidden', width: '100%'
                        }}
                      >
                        <Typography sx={{
                          width: '100%', padding: '10px 20px', background: 'white', borderRadius: '8px', color: '#000000', fontWeight: '500', fontSize: '16px', height: '43px', "&:hover": {
                            background: 'transparent', color: 'white', "img": {
                              filter: 'brightness(100)', mixBlendMode: 'screen'
                            }
                          }
                        }}>
                          View Profile
                        </Typography>
                      </Button>
                    </Stack>
                  </Box>))}
                </Stack>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box sx={{
                boxShadow: '0px 0px 24px 0px rgba(0, 0, 0, 0.10)', borderRadius: '10px',
                height: '420px',
                width: '100%', padding: '16px',
              }}>
                <Stack direction={"row"} justifyContent="space-between" alignItems="center" pb={3}>
                  <Typography fontSize={16} fontWeight={500} color={"#000000"}>Wallet</Typography>
                  <Link style={{ textDecoration: 'none' }} to={"/wallet"}>
                    <Typography fontSize={16} fontWeight={400} color={"var(--color-blue)"} sx={{ textDecoration: 'none' }}>See All</Typography>
                  </Link>
                </Stack>
                <Grid container spacing={3}>
                  <Grid item xs={6}><Box sx={{
                    border: '1px solid #F0F0F0', borderRadius: '6px', padding: '10px 12px', height: '142px', width: '100%', alignContent: "center"
                  }}>
                    <Stack direction="row" justifyContent="flex-start" alignItems={"center"} gap={3} flexWrap="wrap" >
                      <Box >
                        <Stack justifyContent="center" alignItems="center" sx={{ width: '38px', height: '38px', boxShadow: '0px 0px 5px 0px rgba(0, 0, 0, 0.08)', borderRadius: '4px', marginBottom: '12px', padding: '7px' }}>
                          <img src={ruppeeIcon} alt={ruppeeIcon} style={{ width: '24px', height: '24px' }} />
                        </Stack>
                        <Typography sx={{ fontWeight: 600, fontSize: '16px', color: '#151314', marginBottom: '5px' }}>₹{formatPrice(parseFloat(walletDetails?.availableBalance) + parseFloat(walletDetails.withdrawPendingBalance))}</Typography>
                        <Typography sx={{ fontWeight: 400, fontSize: '14px', color: '#726C6C', }}>Current balance</Typography>
                      </Box>
                    </Stack>
                  </Box></Grid>
                  <Grid item xs={6}><Box sx={{
                    border: '1px solid #F0F0F0', borderRadius: '6px', padding: '10px 12px', height: '142px', width: '100%', alignContent: "center"
                  }}>
                    <Stack direction="row" justifyContent="flex-start" gap={3} flexWrap="wrap" >
                      <Box sx={{}}>
                        <Stack justifyContent="center" alignItems="center" sx={{ width: '38px', height: '38px', boxShadow: '0px 0px 5px 0px rgba(0, 0, 0, 0.08)', borderRadius: '4px', marginBottom: '12px', padding: '7px' }}>
                          <img src={lockIcon} alt={ruppeeIcon} style={{ width: '24px', height: '24px' }} />
                        </Stack>
                        <Typography sx={{ fontWeight: 600, fontSize: '16px', color: '#151314', marginBottom: '5px' }}>₹{formatPrice(walletDetails.withdrawPendingBalance)}</Typography>
                        <Typography sx={{ fontWeight: 400, fontSize: '14px', color: '#726C6C', }}>Blocked balance</Typography>
                      </Box>
                    </Stack>
                  </Box></Grid>
                  <Grid item xs={6}><Box sx={{
                    border: '1px solid #F0F0F0', borderRadius: '6px', padding: '10px 12px', height: '142px', width: '100%', alignContent: "center"
                  }}>
                    <Stack direction="row" justifyContent="flex-start" gap={3} flexWrap="wrap" >
                      <Box sx={{}}>
                        <Stack justifyContent="center" alignItems="center" sx={{ width: '38px', height: '38px', boxShadow: '0px 0px 5px 0px rgba(0, 0, 0, 0.08)', borderRadius: '4px', marginBottom: '12px', padding: '7px' }}>
                          <img src={moneyPotIcon} alt={ruppeeIcon} style={{ width: '24px', height: '24px' }} />
                        </Stack>
                        <Typography sx={{ fontWeight: 600, fontSize: '16px', color: '#151314', marginBottom: '5px' }}>₹{formatPrice(parseFloat(walletDetails?.availableBalance))}</Typography>
                        <Typography sx={{ fontWeight: 400, fontSize: '14px', color: '#726C6C', }}>Available balance</Typography>
                      </Box>
                    </Stack>
                  </Box></Grid>
                  <Grid item xs={6}><Box onClick={() => setAddPaymentOpen(true)} sx={{
                    border: '1px solid #F0F0F0', borderRadius: '6px', padding: '10px 12px', height: '142px', width: '100%', alignContent: "center", background: `url(${addMoneyWalletBg})`, cursor: 'pointer'
                  }}>
                    <Stack direction="column" justifyContent="center" alignItems="center" gap={0} flexWrap="wrap" >
                      <Stack justifyContent="center" alignItems="center" sx={{ width: '38px', height: '38px', boxShadow: '0px 0px 5px 0px rgba(0, 0, 0, 0.08)', borderRadius: '4px', marginBottom: '12px', padding: '7px', background: 'rgba(242, 242, 242, 0.20)', backdropFilter: 'blur(2px)' }}>
                        <img src={creditCardIcon} alt={ruppeeIcon} style={{ width: '24px', height: '24px' }} />
                      </Stack>
                      <Typography sx={{ fontWeight: 500, fontSize: '14px', color: '#2B2829', }}>Add Money</Typography>
                    </Stack>
                  </Box></Grid>
                </Grid>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box sx={{
                boxShadow: '0px 0px 24px 0px rgba(0, 0, 0, 0.10)', borderRadius: '10px',
                height: '420px',
                width: '100%', padding: '16px',
              }}>
                <Stack direction={"row"} justifyContent="space-between" alignItems="center" pb={3} sx={{ height: '10%', border: '0px solid red' }}>
                  <Typography fontSize={16} fontWeight={500} color={"#000000"}>Influencer Status</Typography>
                </Stack>
                {influencerStatus?.length > 0 ? <Stack direction="column" gap={2} sx={{
                  height: '90%', overflowX: 'hidden', overflowY: 'scroll', scrollbarWidth: 'none',
                  '&::-webkit-scrollbar': {
                    display: 'none',
                  },
                }}>
                  {influencerStatus?.map((item) => {
                    const status = item?.influencerBiddingStatus === 'publish' ? "Link Publish" : item.influencerBiddingStatus === 'review' ? "Content Upload" : item.influencerBiddingStatus === 'script' ? "Script Upload" : "Approved"
                    const statusCss = getStatusCss(status);
                    return (
                      <Stack sx={{ border: '1px solid #F0F0F0', borderRadius: '6px', padding: '10px 12px', width: '100%', height: '65px' }} direction="row" justifyContent="space-between" alignItems={"center"}>
                        <Stack direction="row" justifyContent="flex-start" gap={2} alignItems="center">
                          <Avatar src={item.influencerPicture} sx={{ height: '40px', width: '40px' }} />
                          <Stack direction="column" gap={0.5}>
                            <Typography fontSize={14} fontWeight={500} color={"#000000"} textTransform={"capitalize"}>{trunCateString(item?.influencerName, isScreenZoomed ? 8 : 20)}</Typography>
                            <Typography fontSize={14} fontWeight={400} color="#726C6C" px={1} border={"1px solid #92C5FF"} textTransform={"capitalize"} borderRadius={50}>{trunCateString(item?.campaignName, isScreenZoomed ? 8 : 20)}</Typography>
                          </Stack>
                        </Stack>
                        <Stack direction="column" gap={0.5} justifyContent="flex-end" alignItems="end">
                          <Box sx={{ borderRadius: '50px', padding: '4px 8px', ...statusCss }}>
                            <Typography fontSize={12} fontWeight={400} >{status}</Typography>
                          </Box>
                          <Button onClick={() => navigate(`/my-campaigns/approved-influencer/${item?.campaignId}`,{ state: { showContentModal: true,influencerId:item?.influencerId } })} sx={{
                            minWidth: 'fit-content', padding: '0px', width: 'fit-content', height: 'fit-content', background: 'none', "&:hover": {
                              background: 'none'
                            }
                          }} disableRipple>
                            <Stack direction="row">
                              <Typography fontSize={12} fontWeight={400} color="var(--color-blue)">View</Typography><img src={blueUpwardArrow} alt="blueUpwardArrow" style={{ width: '16px', height: '16px' }} />
                            </Stack>
                          </Button>
                        </Stack>
                      </Stack>
                    )
                  })}
                </Stack> : <Stack  direction="column" gap={1} sx={{ height: '90%', }} justifyContent="center" alignItems="center">
                  <Typography fontSize={14} fontWeight={400} color="#726C6C">There is no campaign, start  creating campaign</Typography>
                    <Button
                    onClick={()=>navigate('/campaign/type')}
                      sx={{
                        marginTop: '24px', borderRadius: '10px', position: 'relative', background: 'linear-gradient(90deg,rgba(255, 204, 112, 1) 0%, rgba(200, 80, 192, 1) 50%, rgba(65, 88, 208, 1) 100%)', padding: '2px', overflow: 'hidden', width: '100%'
                      }}
                    >
                      <Typography sx={{
                        width: '100%', padding: '10px 20px', background: 'white', borderRadius: '8px', color: '#000000', fontWeight: '500', fontSize: '16px', height: '43px', "&:hover": {
                          background: 'transparent', color: 'white', "img": {
                            filter: 'brightness(100)', mixBlendMode: 'screen'
                          }
                        }
                      }}>
                        Create New Campaign <img src={arrow} alt="" style={{ width: '20px', height: '20px', rotate: '180deg' }} />
                      </Typography>
                    </Button>
                </Stack>}
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>) : (
        <><Stack direction={"column"} gap={2} sx={{ padding: '32px' }}>
          <Stack
            display={'none'}
            direction={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
            sx={{
              minHeight: '42px'
            }}
          >
            <Typography variant="h1" className="page-title">
              Dashboard
            </Typography>
          </Stack>
          <Box
            sx={{
              backgroundColor: '#EFEEF4',
              transition: 'all .5s ease-in-out',
              position: 'relative',
              border: '1px solid rgba(170, 170, 170, 0.3)',
              borderRadius: '12px',
              boxShadow: '0px 5px 5px 0px rgba(82, 63, 105, 0.05)',
              overflow: 'hidden',
            }}>
            <div className='px-4 pt-4 pb-5'>
              <div className='dashPgeTbs'>
                <div className='viewDetTabs dashboardPage mx-auto'>
                  <button className={active === 1 ? "active" : ""}
                    onClick={() => setActive(1)}
                  >
                    All
                  </button>
                  <button className={active === 2 ? "active" : ""}
                    onClick={() => setActive(2)}
                  >
                    My Campaigns
                  </button>
                  <button className={active === 3 ? "active" : ""}
                    onClick={() => setActive(3)}
                  >
                    Communities
                  </button>
                  <button className={active === 4 ? "active" : ""}
                    onClick={() => setActive(4)}
                  >
                    Demo Campaigns
                  </button>
                  <button className={active === 5 ? "active" : ""}
                    onClick={() => setActive(5)}
                  >
                    Analytics
                  </button>
                </div>
              </div>
            </div>
            {getUserType() === COMPANY && <div className='row'>
              <div className='col-12'>
                <div className='d-flex align-items-center justify-content-between px-xxl-5 px-xl-5 px-lg-5 px-md-4 px-sm-3 px-3 mb-4'>
                  <Typography className="fs-4 d-flex text-nowrap" variant="h4" component="h4">My Campaigns 🎉</Typography>
                  {myCampaigns.length > 0 && <Link className="text-decoration-underline" href="#" onClick={(e) => { e.preventDefault(); navigate("/my-campaigns"); }} style={{ fontSize: '14px', fontWeight: '500' }}>View All</Link>}
                </div>
                <div className='myCampSliders crtecmp px-xxl-5 px-xl-5 px-lg-5 px-md-4 px-sm-3 px-3'>
                  {myCampaigns.length > 0 ? <Carousel
                    responsive={responsive}
                    itemClass="carousel-item-padding-40-px"
                  >
                    <div>
                      <Card
                        className="createNew dashCard campaign-dashboard-card-height"
                        borderRadius={12}
                        sx={{
                          position: 'relative',
                          cursor: 'pointer',
                          borderRadius: '12px',
                          padding: '1rem',
                          minHeight: '201.08px'
                        }}
                        onClick={() => {
                          if (brandsDropdown.length > 0) {
                            dispatch(updateCampaign({ formData: {}, affliateSection: 0, deliverablesSection: 0, addtionalSection: 0, detailsSection: 0, searchedInfluencers: [], searchedInfluencersCheckboxIds: [], searchedInfluencersInvitedIds: [], suggestedInfluencers: [] }));
                            navigate("/campaign/type");
                          } else {
                            setModelOpen(true);
                          }
                        }}
                      >
                        <Stack gap={2} direction={'row'}>
                          <Stack style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <AddCircleIcon />
                            <Typography className="mb-1 fw-400" variant="h4" component="h4">Create<br />New</Typography>
                          </Stack>
                        </Stack>
                      </Card>
                    </div>
                    {myCampaigns.length > 0 ? myCampaigns.map((v, i) => {
                      return <div key={v.id + myCampaigns.length}>
                        <Card
                          className="dashCard campaign-dashboard-card campaign-dashboard-card-height"
                          borderRadius={12}
                          sx={{
                            borderRadius: '12px',
                            width: 'auto'
                          }}
                          key={v.id + myCampaigns.length}
                          onClick={() => { navigate("/campaign/partial/details/" + v.id); }}
                        >
                          <Stack className="d-flex" gap={2} direction={'row'}>
                            <Image src={v?.bannerImage.length > 0 ? v?.bannerImage.toString() : "/profile.png"} className='img-fluid d-block rounded-circle' alt="My campaign" style={{ width: '50px', height: '50px' }} />
                            <Stack>
                              {v.name.length > 25 ? <Tooltip title={v.name}><Typography className="mb-1" variant="h4" component="h4"><i>{v.name?.substring(0, 25) + '...'}</i></Typography></Tooltip> : <Typography className="mb-1" variant="h4" component="h4"><i>{v.name}</i></Typography>}
                              <Typography sx={{ fontSize: { xs: "16px", sm: "20px", md: "24px", lg: "28px" } }} variant="h6" component="h6" style={{ fontWeight: 'normal', fontSize: '14px', color: '#aaa', textTransform: 'capitalize' }}>Status: {capitalizeWords(v.status)}</Typography>
                            </Stack>
                          </Stack>
                          <Typography className="d-flex" variant="h6" component="h6" py={3} style={{ lineHeight: 'normal', gap: '10px' }}><span className="label">Created on:</span> <span style={{ fontSize: '14px' }}>{getFormatedDate(v.createdDate, 'DD MMMM YYYY h:mm A')}</span></Typography>
                          <Grid container spacing={2}>
                            <Grid item xs={6} xl={6} lg={6} md={6} sm={6}>
                              <Stack
                                mb={0.5}
                                flex={'flex'}
                                alignItems={'center'}
                                justifyContent={'space-between'}
                                flexDirection={'row'}
                                sx={{
                                  display: 'flex'
                                }}
                              >
                                <Typography sx={{ fontSize: RESPONSIVE_CARD_FONT_SIZE }} component="div">Views</Typography>
                                <Typography sx={{ fontSize: RESPONSIVE_CARD_FONT_SIZE }} variant="h4" component="h6">1234</Typography>
                              </Stack>
                              <Stack
                                flex={'flex'}
                                alignItems={'center'}
                                justifyContent={'space-between'}
                                flexDirection={'row'}
                                sx={{
                                  display: 'flex'
                                }}
                              >
                                <Typography sx={{ fontSize: RESPONSIVE_CARD_FONT_SIZE }} component="div">Total Posts</Typography>
                                <Typography sx={{ fontSize: RESPONSIVE_CARD_FONT_SIZE }} variant="h4" component="h6">-</Typography>
                              </Stack>
                            </Grid>
                            <Grid item xs={6} xl={6} lg={6} md={6} sm={6} onClick={() => { navigate("/campaign/partial/details/" + v.id); }}>
                              <Stack
                                mb={0.5}
                                alignItems={'center'}
                                justifyContent={'space-between'}
                                flexDirection={'row'}
                                sx={{
                                  display: 'flex',
                                }}
                              >
                                <Typography sx={{ fontSize: RESPONSIVE_CARD_FONT_SIZE }} component="div">Total Reach</Typography>
                                <Typography sx={{ fontSize: RESPONSIVE_CARD_FONT_SIZE }} variant="h4" component="h6">-</Typography>
                              </Stack>
                              <Stack
                                alignItems={'center'}
                                justifyContent={'space-between'}
                                flexDirection={'row'}
                                sx={{
                                  display: 'flex'
                                }}
                              >
                                <Typography sx={{ fontSize: RESPONSIVE_CARD_FONT_SIZE }} component="div">CPR</Typography>
                                <Typography sx={{ fontSize: RESPONSIVE_CARD_FONT_SIZE }} variant="h4" component="h6">-</Typography>
                              </Stack>
                            </Grid>
                          </Grid>
                        </Card>
                      </div>;
                    }) : <p className='card fs-1 mb-0 py-5 d-flex align-items-center justify-content-center'>Coming Soon</p>}
                  </Carousel> : <div style={{ width: "30%" }}>
                    <Card
                      className="createNew dashCard"
                      borderRadius={12}
                      sx={{
                        height: 'auto',
                        position: 'relative',
                        cursor: 'pointer',
                        borderRadius: '12px',
                        padding: '1rem',
                        minHeight: '222px'
                      }}
                      onClick={() => {
                        if (brandsDropdown.length > 0) {
                          navigate("/campaign/type");
                        } else {
                          setModelOpen(true);
                        }
                      }}
                    >
                      <Stack gap={2} direction={'row'}>
                        <Stack style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <AddCircleIcon />
                          <Typography className="mb-1 fw-400" variant="h4" component="h4">Create New</Typography>
                        </Stack>
                      </Stack>
                    </Card>
                  </div>}
                </div>
              </div>
            </div>}
            <div className='row mt-5'>
              <div className='col-12'>
                <div className='d-flex align-items-center justify-content-between px-xxl-5 px-xl-5 px-lg-5 px-md-4 px-sm-3 px-3 mb-4'>
                  <Typography className="fs-4 d-flex text-nowrap" variant="h4" component="h4">Communities 👥</Typography>
                </div>
                <div className='dashCommunities communityBlock px-xxl-5 px-xl-5 px-lg-5 px-md-4 px-sm-3 px-3'>
                  <p className='card fs-1 mb-0 py-5 d-flex align-items-center justify-content-center'>Coming Soon</p>
                  {false && <Carousel
                    responsive={responsive}
                    itemClass="carousel-item-padding-40-px"
                  >
                    <div>
                      <Card
                        className="commItem"
                        borderRadius={12}
                        sx={{
                          height: '172px',
                          position: 'relative',
                          cursor: 'pointer',
                          borderRadius: '12px',
                          padding: '1rem'
                        }}
                      >
                        <Stack
                          sx={{
                            display: 'flex',
                            flexWrap: 'wrap'
                          }}
                        >
                          <Typography className="fs-6 text-white" variant="h6" component="h6" style={{ fontWeight: 'normal' }} mb={1}>Entertainment</Typography>
                          <Typography className="text-white" variant="h4" component="h4">Dancers</Typography>
                          <Stack className="imgwplatform" sx={{ flexDirection: 'row' }}>
                            <Typography component="div" className="brandProfImg">
                              <Image src={influencerProfImgs} className='img-fluid' alt="Influencer Profile" width={32} height={32} />
                              <Image src={influencerProfImgs} className='img-fluid' alt="Influencer Profile" width={32} height={32} />
                              <Image src={influencerProfImgs} className='img-fluid' alt="Influencer Profile" width={32} height={32} />
                              <Image src={influencerProfImgs} className='img-fluid' alt="Influencer Profile" width={32} height={32} />
                              <Image src={influencerProfImgs} className='img-fluid' alt="Influencer Profile" width={32} height={32} />
                            </Typography>
                            <Image src={socialIcons} className='img-fluid' alt="Social Icons" width={32} height={32} />
                          </Stack>
                        </Stack>
                      </Card>
                    </div>
                    <div>
                      <Card
                        className="commItem"
                        borderRadius={12}
                        sx={{
                          height: '172px',
                          position: 'relative',
                          cursor: 'pointer',
                          borderRadius: '12px',
                          padding: '1rem'
                        }}
                      >
                        <Stack
                          sx={{
                            display: 'flex',
                            flexWrap: 'wrap'
                          }}
                        >
                          <Typography className="fs-6 text-white" variant="h6" component="h6" style={{ fontWeight: 'normal' }} mb={1}>Entertainment</Typography>
                          <Typography className="text-white" variant="h4" component="h4">Dancers</Typography>
                          <Stack className="imgwplatform" sx={{ flexDirection: 'row' }}>
                            <Typography component="div" className="brandProfImg">
                              <Image src={influencerProfImgs} className='img-fluid' alt="Influencer Profile" width={32} height={32} />
                              <Image src={influencerProfImgs} className='img-fluid' alt="Influencer Profile" width={32} height={32} />
                              <Image src={influencerProfImgs} className='img-fluid' alt="Influencer Profile" width={32} height={32} />
                              <Image src={influencerProfImgs} className='img-fluid' alt="Influencer Profile" width={32} height={32} />
                              <Image src={influencerProfImgs} className='img-fluid' alt="Influencer Profile" width={32} height={32} />
                            </Typography>
                            <Image src={socialIcons} className='img-fluid' alt="Social Icons" width={32} height={32} />
                          </Stack>
                        </Stack>
                      </Card>
                    </div>
                    <div>
                      <Card
                        className="commItem"
                        borderRadius={12}
                        sx={{
                          height: '172px',
                          position: 'relative',
                          cursor: 'pointer',
                          borderRadius: '12px',
                          padding: '1rem'
                        }}
                      >
                        <Stack
                          sx={{
                            display: 'flex',
                            flexWrap: 'wrap'
                          }}
                        >
                          <Typography className="fs-6 text-white" variant="h6" component="h6" style={{ fontWeight: 'normal' }} mb={1}>Entertainment</Typography>
                          <Typography className="text-white" variant="h4" component="h4">Dancers</Typography>
                          <Stack className="imgwplatform" sx={{ flexDirection: 'row' }}>
                            <Typography component="div" className="brandProfImg">
                              <Image src={influencerProfImgs} className='img-fluid' alt="Influencer Profile" width={32} height={32} />
                              <Image src={influencerProfImgs} className='img-fluid' alt="Influencer Profile" width={32} height={32} />
                              <Image src={influencerProfImgs} className='img-fluid' alt="Influencer Profile" width={32} height={32} />
                              <Image src={influencerProfImgs} className='img-fluid' alt="Influencer Profile" width={32} height={32} />
                              <Image src={influencerProfImgs} className='img-fluid' alt="Influencer Profile" width={32} height={32} />
                            </Typography>
                            <Image src={socialIcons} className='img-fluid' alt="Social Icons" width={32} height={32} />
                          </Stack>
                        </Stack>
                      </Card>
                    </div>
                    <div>
                      <Card
                        className="commItem"
                        borderRadius={12}
                        sx={{
                          height: '172px',
                          position: 'relative',
                          cursor: 'pointer',
                          borderRadius: '12px',
                          padding: '1rem'
                        }}
                      >
                        <Stack
                          sx={{
                            display: 'flex',
                            flexWrap: 'wrap'
                          }}
                        >
                          <Typography className="fs-6 text-white" variant="h6" component="h6" style={{ fontWeight: 'normal' }} mb={1}>Entertainment</Typography>
                          <Typography className="text-white" variant="h4" component="h4">Dancers</Typography>
                          <Stack className="imgwplatform" sx={{ flexDirection: 'row' }}>
                            <Typography component="div" className="brandProfImg">
                              <Image src={influencerProfImgs} className='img-fluid' alt="Influencer Profile" width={32} height={32} />
                              <Image src={influencerProfImgs} className='img-fluid' alt="Influencer Profile" width={32} height={32} />
                              <Image src={influencerProfImgs} className='img-fluid' alt="Influencer Profile" width={32} height={32} />
                              <Image src={influencerProfImgs} className='img-fluid' alt="Influencer Profile" width={32} height={32} />
                              <Image src={influencerProfImgs} className='img-fluid' alt="Influencer Profile" width={32} height={32} />
                            </Typography>
                            <Image src={socialIcons} className='img-fluid' alt="Social Icons" width={32} height={32} />
                          </Stack>
                        </Stack>
                      </Card>
                    </div>
                    <div>
                      <Card
                        className="commItem"
                        borderRadius={12}
                        sx={{
                          height: '172px',
                          position: 'relative',
                          cursor: 'pointer',
                          borderRadius: '12px',
                          padding: '1rem'
                        }}
                      >
                        <Stack
                          sx={{
                            display: 'flex',
                            flexWrap: 'wrap'
                          }}
                        >
                          <Typography className="fs-6 text-white" variant="h6" component="h6" style={{ fontWeight: 'normal' }} mb={1}>Entertainment</Typography>
                          <Typography className="text-white" variant="h4" component="h4">Dancers</Typography>
                          <Stack className="imgwplatform" sx={{ flexDirection: 'row' }}>
                            <Typography component="div" className="brandProfImg">
                              <Image src={influencerProfImgs} className='img-fluid' alt="Influencer Profile" width={32} height={32} />
                              <Image src={influencerProfImgs} className='img-fluid' alt="Influencer Profile" width={32} height={32} />
                              <Image src={influencerProfImgs} className='img-fluid' alt="Influencer Profile" width={32} height={32} />
                              <Image src={influencerProfImgs} className='img-fluid' alt="Influencer Profile" width={32} height={32} />
                              <Image src={influencerProfImgs} className='img-fluid' alt="Influencer Profile" width={32} height={32} />
                            </Typography>
                            <Image src={socialIcons} className='img-fluid' alt="Social Icons" width={32} height={32} />
                          </Stack>
                        </Stack>
                      </Card>
                    </div>
                    <div>
                      <Card
                        className="commItem"
                        borderRadius={12}
                        sx={{
                          height: '172px',
                          position: 'relative',
                          cursor: 'pointer',
                          borderRadius: '12px',
                          padding: '1rem'
                        }}
                      >
                        <Stack
                          sx={{
                            display: 'flex',
                            flexWrap: 'wrap'
                          }}
                        >
                          <Typography className="fs-6 text-white" variant="h6" component="h6" style={{ fontWeight: 'normal' }} mb={1}>Entertainment</Typography>
                          <Typography className="text-white" variant="h4" component="h4">Dancers</Typography>
                          <Stack className="imgwplatform" sx={{ flexDirection: 'row' }}>
                            <Typography component="div" className="brandProfImg">
                              <Image src={influencerProfImgs} className='img-fluid' alt="Influencer Profile" width={32} height={32} />
                              <Image src={influencerProfImgs} className='img-fluid' alt="Influencer Profile" width={32} height={32} />
                              <Image src={influencerProfImgs} className='img-fluid' alt="Influencer Profile" width={32} height={32} />
                              <Image src={influencerProfImgs} className='img-fluid' alt="Influencer Profile" width={32} height={32} />
                              <Image src={influencerProfImgs} className='img-fluid' alt="Influencer Profile" width={32} height={32} />
                            </Typography>
                            <Image src={socialIcons} className='img-fluid' alt="Social Icons" width={32} height={32} />
                          </Stack>
                        </Stack>
                      </Card>
                    </div>
                  </Carousel>}
                </div>
              </div>
            </div>
            <div className='row mt-5 mb-5'>
              <div className='col-12'>
                <div className='d-flex align-items-center justify-content-between px-xxl-5 px-xl-5 px-lg-5 px-md-4 px-sm-3 px-3 mb-4'>
                  <Typography className="fs-4 d-flex text-nowrap" variant="h4" component="h4">Competitor recent Campaigns 📢</Typography>
                </div>
                <div className='  communityBlock competitorBlock px-xxl-5 px-xl-5 px-lg-5 px-md-4 px-sm-3 px-3'>
                  <p className='card fs-1 mb-0 py-5 d-flex align-items-center justify-content-center'>Coming Soon</p>
                  {false && <Carousel
                    responsive={responsive}
                    itemClass="carousel-item-padding-40-px"
                  >
                    <div>
                      <Card
                        className="dashCard"
                        borderRadius={12}
                        sx={{
                          height: 'auto',
                          position: 'relative',
                          cursor: 'pointer',
                          borderRadius: '12px',
                          padding: '1rem'
                        }}
                      >
                        <Stack className="d-flex" gap={2} direction={'row'}>
                          <Image src={influencerProfImgs} className='img-fluid d-block rounded-circle' alt="Influencer Profile" style={{ width: '50px', height: '50px' }} />
                          <Stack>
                            <Typography className="mb-1" variant="h4" component="h4"><i>Drivig_Naari</i></Typography>
                            <Typography variant="h6" component="h6" style={{ fontWeight: 'normal', fontSize: '14px', color: '#aaa' }}>Status: Closed</Typography>
                          </Stack>
                        </Stack>
                        <Typography className="d-flex" variant="h6" component="h6" py={3} style={{ lineHeight: 'normal', gap: '10px' }}><span className="label">Created on:</span> <span style={{ fontSize: '14px' }}>01 April 2024 2:05 PM</span></Typography>
                        <Grid container spacing={3}>
                          <Grid item xs={6} xl={6} lg={6} md={6} sm={6}>
                            <Stack
                              mb={0.5}
                              flex={'flex'}
                              alignItems={'center'}
                              justifyContent={'space-between'}
                              flexDirection={'row'}
                              sx={{
                                display: 'flex'
                              }}
                            >
                              <Typography className="fs-6" component="div">Total Reach</Typography>
                              <Typography className="fs-6" variant="h4" component="h6">500K</Typography>
                            </Stack>
                            <Stack
                              flex={'flex'}
                              alignItems={'center'}
                              justifyContent={'space-between'}
                              flexDirection={'row'}
                              sx={{
                                display: 'flex'
                              }}
                            >
                              <Typography className="fs-6" component="div">CPR</Typography>
                              <Typography className="fs-6" variant="h4" component="h6">5</Typography>
                            </Stack>
                          </Grid>
                          <Grid item xs={6} xl={6} lg={6} md={6} sm={6}>
                            <Stack
                              mb={0.5}
                              flex={'flex'}
                              alignItems={'center'}
                              justifyContent={'space-between'}
                              flexDirection={'row'}
                              sx={{
                                display: 'flex'
                              }}
                            >
                              <Typography className="fs-6" component="div">Views</Typography>
                              <Typography className="fs-6" variant="h4" component="h6">500K</Typography>
                            </Stack>
                            <Stack
                              flex={'flex'}
                              alignItems={'center'}
                              justifyContent={'space-between'}
                              flexDirection={'row'}
                              sx={{
                                display: 'flex'
                              }}
                            >
                              <Typography className="fs-6" component="div">Total Posts</Typography>
                              <Typography className="fs-6" variant="h4" component="h6">5</Typography>
                            </Stack>
                          </Grid>
                        </Grid>
                      </Card>
                    </div>
                    <div>
                      <Card
                        className="dashCard"
                        borderRadius={12}
                        sx={{
                          height: 'auto',
                          position: 'relative',
                          cursor: 'pointer',
                          borderRadius: '12px',
                          padding: '1rem'
                        }}
                      >
                        <Stack className="d-flex" gap={2} direction={'row'}>
                          <Image src={influencerProfImgs} className='img-fluid d-block rounded-circle' alt="Influencer Profile" style={{ width: '50px', height: '50px' }} />
                          <Stack>
                            <Typography className="mb-1" variant="h4" component="h4"><i>Drivig_Naari</i></Typography>
                            <Typography variant="h6" component="h6" style={{ fontWeight: 'normal', fontSize: '14px', color: '#aaa' }}>Status: Closed</Typography>
                          </Stack>
                        </Stack>
                        <Typography className="d-flex" variant="h6" component="h6" py={3} style={{ lineHeight: 'normal', gap: '10px' }}><span className="label">Created on:</span> <span style={{ fontSize: '14px' }}>01 April 2024 2:05 PM</span></Typography>
                        <Grid container spacing={3}>
                          <Grid item xs={6} xl={6} lg={6} md={6} sm={6}>
                            <Stack
                              mb={0.5}
                              flex={'flex'}
                              alignItems={'center'}
                              justifyContent={'space-between'}
                              flexDirection={'row'}
                              sx={{
                                display: 'flex'
                              }}
                            >
                              <Typography className="fs-6" component="div">Total Reach</Typography>
                              <Typography className="fs-6" variant="h4" component="h6">500K</Typography>
                            </Stack>
                            <Stack
                              flex={'flex'}
                              alignItems={'center'}
                              justifyContent={'space-between'}
                              flexDirection={'row'}
                              sx={{
                                display: 'flex'
                              }}
                            >
                              <Typography className="fs-6" component="div">CPR</Typography>
                              <Typography className="fs-6" variant="h4" component="h6">5</Typography>
                            </Stack>
                          </Grid>
                          <Grid item xs={6} xl={6} lg={6} md={6} sm={6}>
                            <Stack
                              mb={0.5}
                              flex={'flex'}
                              alignItems={'center'}
                              justifyContent={'space-between'}
                              flexDirection={'row'}
                              sx={{
                                display: 'flex'
                              }}
                            >
                              <Typography className="fs-6" component="div">Views</Typography>
                              <Typography className="fs-6" variant="h4" component="h6">500K</Typography>
                            </Stack>
                            <Stack
                              flex={'flex'}
                              alignItems={'center'}
                              justifyContent={'space-between'}
                              flexDirection={'row'}
                              sx={{
                                display: 'flex'
                              }}
                            >
                              <Typography className="fs-6" component="div">Total Posts</Typography>
                              <Typography className="fs-6" variant="h4" component="h6">5</Typography>
                            </Stack>
                          </Grid>
                        </Grid>
                      </Card>
                    </div>
                    <div>
                      <Card
                        className="dashCard"
                        borderRadius={12}
                        sx={{
                          height: 'auto',
                          position: 'relative',
                          cursor: 'pointer',
                          borderRadius: '12px',
                          padding: '1rem'
                        }}
                      >
                        <Stack className="d-flex" gap={2} direction={'row'}>
                          <Image src={influencerProfImgs} className='img-fluid d-block rounded-circle' alt="Influencer Profile" style={{ width: '50px', height: '50px' }} />
                          <Stack>
                            <Typography className="mb-1" variant="h4" component="h4"><i>Drivig_Naari</i></Typography>
                            <Typography variant="h6" component="h6" style={{ fontWeight: 'normal', fontSize: '14px', color: '#aaa' }}>Status: Closed</Typography>
                          </Stack>
                        </Stack>
                        <Typography className="d-flex" variant="h6" component="h6" py={3} style={{ lineHeight: 'normal', gap: '10px' }}><span className="label">Created on:</span> <span style={{ fontSize: '14px' }}>01 April 2024 2:05 PM</span></Typography>
                        <Grid container spacing={3}>
                          <Grid item xs={6} xl={6} lg={6} md={6} sm={6}>
                            <Stack
                              mb={0.5}
                              flex={'flex'}
                              alignItems={'center'}
                              justifyContent={'space-between'}
                              flexDirection={'row'}
                              sx={{
                                display: 'flex'
                              }}
                            >
                              <Typography className="fs-6" component="div">Total Reach</Typography>
                              <Typography className="fs-6" variant="h4" component="h6">500K</Typography>
                            </Stack>
                            <Stack
                              flex={'flex'}
                              alignItems={'center'}
                              justifyContent={'space-between'}
                              flexDirection={'row'}
                              sx={{
                                display: 'flex'
                              }}
                            >
                              <Typography className="fs-6" component="div">CPR</Typography>
                              <Typography className="fs-6" variant="h4" component="h6">5</Typography>
                            </Stack>
                          </Grid>
                          <Grid item xs={6} xl={6} lg={6} md={6} sm={6}>
                            <Stack
                              mb={0.5}
                              flex={'flex'}
                              alignItems={'center'}
                              justifyContent={'space-between'}
                              flexDirection={'row'}
                              sx={{
                                display: 'flex'
                              }}
                            >
                              <Typography className="fs-6" component="div">Views</Typography>
                              <Typography className="fs-6" variant="h4" component="h6">500K</Typography>
                            </Stack>
                            <Stack
                              flex={'flex'}
                              alignItems={'center'}
                              justifyContent={'space-between'}
                              flexDirection={'row'}
                              sx={{
                                display: 'flex'
                              }}
                            >
                              <Typography className="fs-6" component="div">Total Posts</Typography>
                              <Typography className="fs-6" variant="h4" component="h6">5</Typography>
                            </Stack>
                          </Grid>
                        </Grid>
                      </Card>
                    </div>
                    <div>
                      <Card
                        className="dashCard"
                        borderRadius={12}
                        sx={{
                          height: 'auto',
                          position: 'relative',
                          cursor: 'pointer',
                          borderRadius: '12px',
                          padding: '1rem'
                        }}
                      >
                        <Stack className="d-flex" gap={2} direction={'row'}>
                          <Image src={influencerProfImgs} className='img-fluid d-block rounded-circle' alt="Influencer Profile" style={{ width: '50px', height: '50px' }} />
                          <Stack>
                            <Typography className="mb-1" variant="h4" component="h4"><i>Drivig_Naari</i></Typography>
                            <Typography variant="h6" component="h6" style={{ fontWeight: 'normal', fontSize: '14px', color: '#aaa' }}>Status: Closed</Typography>
                          </Stack>
                        </Stack>
                        <Typography className="d-flex" variant="h6" component="h6" py={3} style={{ lineHeight: 'normal', gap: '10px' }}><span className="label">Created on:</span> <span style={{ fontSize: '14px' }}>01 April 2024 2:05 PM</span></Typography>
                        <Grid container spacing={3}>
                          <Grid item xs={6} xl={6} lg={6} md={6} sm={6}>
                            <Stack
                              mb={0.5}
                              flex={'flex'}
                              alignItems={'center'}
                              justifyContent={'space-between'}
                              flexDirection={'row'}
                              sx={{
                                display: 'flex'
                              }}
                            >
                              <Typography className="fs-6" component="div">Total Reach</Typography>
                              <Typography className="fs-6" variant="h4" component="h6">500K</Typography>
                            </Stack>
                            <Stack
                              flex={'flex'}
                              alignItems={'center'}
                              justifyContent={'space-between'}
                              flexDirection={'row'}
                              sx={{
                                display: 'flex'
                              }}
                            >
                              <Typography className="fs-6" component="div">CPR</Typography>
                              <Typography className="fs-6" variant="h4" component="h6">5</Typography>
                            </Stack>
                          </Grid>
                          <Grid item xs={6} xl={6} lg={6} md={6} sm={6}>
                            <Stack
                              mb={0.5}
                              flex={'flex'}
                              alignItems={'center'}
                              justifyContent={'space-between'}
                              flexDirection={'row'}
                              sx={{
                                display: 'flex'
                              }}
                            >
                              <Typography className="fs-6" component="div">Views</Typography>
                              <Typography className="fs-6" variant="h4" component="h6">500K</Typography>
                            </Stack>
                            <Stack
                              flex={'flex'}
                              alignItems={'center'}
                              justifyContent={'space-between'}
                              flexDirection={'row'}
                              sx={{
                                display: 'flex'
                              }}
                            >
                              <Typography className="fs-6" component="div">Total Posts</Typography>
                              <Typography className="fs-6" variant="h4" component="h6">5</Typography>
                            </Stack>
                          </Grid>
                        </Grid>
                      </Card>
                    </div>
                    <div>
                      <Card
                        className="dashCard"
                        borderRadius={12}
                        sx={{
                          height: 'auto',
                          position: 'relative',
                          cursor: 'pointer',
                          borderRadius: '12px',
                          padding: '1rem'
                        }}
                      >
                        <Stack className="d-flex" gap={2} direction={'row'}>
                          <Image src={influencerProfImgs} className='img-fluid d-block rounded-circle' alt="Influencer Profile" style={{ width: '50px', height: '50px' }} />
                          <Stack>
                            <Typography className="mb-1" variant="h4" component="h4"><i>Drivig_Naari</i></Typography>
                            <Typography variant="h6" component="h6" style={{ fontWeight: 'normal', fontSize: '14px', color: '#aaa' }}>Status: Closed</Typography>
                          </Stack>
                        </Stack>
                        <Typography className="d-flex" variant="h6" component="h6" py={3} style={{ lineHeight: 'normal', gap: '10px' }}><span className="label">Created on:</span> <span style={{ fontSize: '14px' }}>01 April 2024 2:05 PM</span></Typography>
                        <Grid container spacing={3}>
                          <Grid item xs={6} xl={6} lg={6} md={6} sm={6}>
                            <Stack
                              mb={0.5}
                              flex={'flex'}
                              alignItems={'center'}
                              justifyContent={'space-between'}
                              flexDirection={'row'}
                              sx={{
                                display: 'flex'
                              }}
                            >
                              <Typography className="fs-6" component="div">Total Reach</Typography>
                              <Typography className="fs-6" variant="h4" component="h6">500K</Typography>
                            </Stack>
                            <Stack
                              flex={'flex'}
                              alignItems={'center'}
                              justifyContent={'space-between'}
                              flexDirection={'row'}
                              sx={{
                                display: 'flex'
                              }}
                            >
                              <Typography className="fs-6" component="div">CPR</Typography>
                              <Typography className="fs-6" variant="h4" component="h6">5</Typography>
                            </Stack>
                          </Grid>
                          <Grid item xs={6} xl={6} lg={6} md={6} sm={6}>
                            <Stack
                              mb={0.5}
                              flex={'flex'}
                              alignItems={'center'}
                              justifyContent={'space-between'}
                              flexDirection={'row'}
                              sx={{
                                display: 'flex'
                              }}
                            >
                              <Typography className="fs-6" component="div">Views</Typography>
                              <Typography className="fs-6" variant="h4" component="h6">500K</Typography>
                            </Stack>
                            <Stack
                              flex={'flex'}
                              alignItems={'center'}
                              justifyContent={'space-between'}
                              flexDirection={'row'}
                              sx={{
                                display: 'flex'
                              }}
                            >
                              <Typography className="fs-6" component="div">Total Posts</Typography>
                              <Typography className="fs-6" variant="h4" component="h6">5</Typography>
                            </Stack>
                          </Grid>
                        </Grid>
                      </Card>
                    </div>
                    <div>
                      <Card
                        className="dashCard"
                        borderRadius={12}
                        sx={{
                          height: 'auto',
                          position: 'relative',
                          cursor: 'pointer',
                          borderRadius: '12px',
                          padding: '1rem'
                        }}
                      >
                        <Stack className="d-flex" gap={2} direction={'row'}>
                          <Image src={influencerProfImgs} className='img-fluid d-block rounded-circle' alt="Influencer Profile" style={{ width: '50px', height: '50px' }} />
                          <Stack>
                            <Typography className="mb-1" variant="h4" component="h4"><i>Drivig_Naari</i></Typography>
                            <Typography variant="h6" component="h6" style={{ fontWeight: 'normal', fontSize: '14px', color: '#aaa' }}>Status: Closed</Typography>
                          </Stack>
                        </Stack>
                        <Typography className="d-flex" variant="h6" component="h6" py={3} style={{ lineHeight: 'normal', gap: '10px' }}><span className="label">Created on:</span> <span style={{ fontSize: '14px' }}>01 April 2024 2:05 PM</span></Typography>
                        <Grid container spacing={3}>
                          <Grid item xs={6} xl={6} lg={6} md={6} sm={6}>
                            <Stack
                              mb={0.5}
                              flex={'flex'}
                              alignItems={'center'}
                              justifyContent={'space-between'}
                              flexDirection={'row'}
                              sx={{
                                display: 'flex'
                              }}
                            >
                              <Typography className="fs-6" component="div">Total Reach</Typography>
                              <Typography className="fs-6" variant="h4" component="h6">500K</Typography>
                            </Stack>
                            <Stack
                              flex={'flex'}
                              alignItems={'center'}
                              justifyContent={'space-between'}
                              flexDirection={'row'}
                              sx={{
                                display: 'flex'
                              }}
                            >
                              <Typography className="fs-6" component="div">CPR</Typography>
                              <Typography className="fs-6" variant="h4" component="h6">5</Typography>
                            </Stack>
                          </Grid>
                          <Grid item xs={6} xl={6} lg={6} md={6} sm={6}>
                            <Stack
                              mb={0.5}
                              flex={'flex'}
                              alignItems={'center'}
                              justifyContent={'space-between'}
                              flexDirection={'row'}
                              sx={{
                                display: 'flex'
                              }}
                            >
                              <Typography className="fs-6" component="div">Views</Typography>
                              <Typography className="fs-6" variant="h4" component="h6">500K</Typography>
                            </Stack>
                            <Stack
                              flex={'flex'}
                              alignItems={'center'}
                              justifyContent={'space-between'}
                              flexDirection={'row'}
                              sx={{
                                display: 'flex'
                              }}
                            >
                              <Typography className="fs-6" component="div">Total Posts</Typography>
                              <Typography className="fs-6" variant="h4" component="h6">5</Typography>
                            </Stack>
                          </Grid>
                        </Grid>
                      </Card>
                    </div>
                    <div>
                      <Card
                        className="dashCard"
                        borderRadius={12}
                        sx={{
                          height: 'auto',
                          position: 'relative',
                          cursor: 'pointer',
                          borderRadius: '12px',
                          padding: '1rem'
                        }}
                      >
                        <Stack className="d-flex" gap={2} direction={'row'}>
                          <Image src={influencerProfImgs} className='img-fluid d-block rounded-circle' alt="Influencer Profile" style={{ width: '50px', height: '50px' }} />
                          <Stack>
                            <Typography className="mb-1" variant="h4" component="h4"><i>Drivig_Naari</i></Typography>
                            <Typography variant="h6" component="h6" style={{ fontWeight: 'normal', fontSize: '14px', color: '#aaa' }}>Status: Closed</Typography>
                          </Stack>
                        </Stack>
                        <Typography className="d-flex" variant="h6" component="h6" py={3} style={{ lineHeight: 'normal', gap: '10px' }}><span className="label">Created on:</span> <span style={{ fontSize: '14px' }}>01 April 2024 2:05 PM</span></Typography>
                        <Grid container spacing={3}>
                          <Grid item xs={6} xl={6} lg={6} md={6} sm={6}>
                            <Stack
                              mb={0.5}
                              flex={'flex'}
                              alignItems={'center'}
                              justifyContent={'space-between'}
                              flexDirection={'row'}
                              sx={{
                                display: 'flex'
                              }}
                            >
                              <Typography className="fs-6" component="div">Total Reach</Typography>
                              <Typography className="fs-6" variant="h4" component="h6">500K</Typography>
                            </Stack>
                            <Stack
                              flex={'flex'}
                              alignItems={'center'}
                              justifyContent={'space-between'}
                              flexDirection={'row'}
                              sx={{
                                display: 'flex'
                              }}
                            >
                              <Typography className="fs-6" component="div">CPR</Typography>
                              <Typography className="fs-6" variant="h4" component="h6">5</Typography>
                            </Stack>
                          </Grid>
                          <Grid item xs={6} xl={6} lg={6} md={6} sm={6}>
                            <Stack
                              mb={0.5}
                              flex={'flex'}
                              alignItems={'center'}
                              justifyContent={'space-between'}
                              flexDirection={'row'}
                              sx={{
                                display: 'flex'
                              }}
                            >
                              <Typography className="fs-6" component="div">Views</Typography>
                              <Typography className="fs-6" variant="h4" component="h6">500K</Typography>
                            </Stack>
                            <Stack
                              flex={'flex'}
                              alignItems={'center'}
                              justifyContent={'space-between'}
                              flexDirection={'row'}
                              sx={{
                                display: 'flex'
                              }}
                            >
                              <Typography className="fs-6" component="div">Total Posts</Typography>
                              <Typography className="fs-6" variant="h4" component="h6">5</Typography>
                            </Stack>
                          </Grid>
                        </Grid>
                      </Card>
                    </div>
                    <div>
                      <Card
                        className="dashCard"
                        borderRadius={12}
                        sx={{
                          height: 'auto',
                          position: 'relative',
                          cursor: 'pointer',
                          borderRadius: '12px',
                          padding: '1rem'
                        }}
                      >
                        <Stack className="d-flex" gap={2} direction={'row'}>
                          <Image src={influencerProfImgs} className='img-fluid d-block rounded-circle' alt="Influencer Profile" style={{ width: '50px', height: '50px' }} />
                          <Stack>
                            <Typography className="mb-1" variant="h4" component="h4"><i>Drivig_Naari</i></Typography>
                            <Typography variant="h6" component="h6" style={{ fontWeight: 'normal', fontSize: '14px', color: '#aaa' }}>Status: Closed</Typography>
                          </Stack>
                        </Stack>
                        <Typography className="d-flex" variant="h6" component="h6" py={3} style={{ lineHeight: 'normal', gap: '10px' }}><span className="label">Created on:</span> <span style={{ fontSize: '14px' }}>01 April 2024 2:05 PM</span></Typography>
                        <Grid container spacing={3}>
                          <Grid item xs={6} xl={6} lg={6} md={6} sm={6}>
                            <Stack
                              mb={0.5}
                              flex={'flex'}
                              alignItems={'center'}
                              justifyContent={'space-between'}
                              flexDirection={'row'}
                              sx={{
                                display: 'flex'
                              }}
                            >
                              <Typography className="fs-6" component="div">Total Reach</Typography>
                              <Typography className="fs-6" variant="h4" component="h6">500K</Typography>
                            </Stack>
                            <Stack
                              flex={'flex'}
                              alignItems={'center'}
                              justifyContent={'space-between'}
                              flexDirection={'row'}
                              sx={{
                                display: 'flex'
                              }}
                            >
                              <Typography className="fs-6" component="div">CPR</Typography>
                              <Typography className="fs-6" variant="h4" component="h6">5</Typography>
                            </Stack>
                          </Grid>
                          <Grid item xs={6} xl={6} lg={6} md={6} sm={6}>
                            <Stack
                              mb={0.5}
                              flex={'flex'}
                              alignItems={'center'}
                              justifyContent={'space-between'}
                              flexDirection={'row'}
                              sx={{
                                display: 'flex'
                              }}
                            >
                              <Typography className="fs-6" component="div">Views</Typography>
                              <Typography className="fs-6" variant="h4" component="h6">500K</Typography>
                            </Stack>
                            <Stack
                              flex={'flex'}
                              alignItems={'center'}
                              justifyContent={'space-between'}
                              flexDirection={'row'}
                              sx={{
                                display: 'flex'
                              }}
                            >
                              <Typography className="fs-6" component="div">Total Posts</Typography>
                              <Typography className="fs-6" variant="h4" component="h6">5</Typography>
                            </Stack>
                          </Grid>
                        </Grid>
                      </Card>
                    </div>
                    <div>
                      <Card
                        className="dashCard"
                        borderRadius={12}
                        sx={{
                          height: 'auto',
                          position: 'relative',
                          cursor: 'pointer',
                          borderRadius: '12px',
                          padding: '1rem'
                        }}
                      >
                        <Stack className="d-flex" gap={2} direction={'row'}>
                          <Image src={influencerProfImgs} className='img-fluid d-block rounded-circle' alt="Influencer Profile" style={{ width: '50px', height: '50px' }} />
                          <Stack>
                            <Typography className="mb-1" variant="h4" component="h4"><i>Drivig_Naari</i></Typography>
                            <Typography variant="h6" component="h6" style={{ fontWeight: 'normal', fontSize: '14px', color: '#aaa' }}>Status: Closed</Typography>
                          </Stack>
                        </Stack>
                        <Typography className="d-flex" variant="h6" component="h6" py={3} style={{ lineHeight: 'normal', gap: '10px' }}><span className="label">Created on:</span> <span style={{ fontSize: '14px' }}>01 April 2024 2:05 PM</span></Typography>
                        <Grid container spacing={3}>
                          <Grid item xs={6} xl={6} lg={6} md={6} sm={6}>
                            <Stack
                              mb={0.5}
                              flex={'flex'}
                              alignItems={'center'}
                              justifyContent={'space-between'}
                              flexDirection={'row'}
                              sx={{
                                display: 'flex'
                              }}
                            >
                              <Typography className="fs-6" component="div">Total Reach</Typography>
                              <Typography className="fs-6" variant="h4" component="h6">500K</Typography>
                            </Stack>
                            <Stack
                              flex={'flex'}
                              alignItems={'center'}
                              justifyContent={'space-between'}
                              flexDirection={'row'}
                              sx={{
                                display: 'flex'
                              }}
                            >
                              <Typography className="fs-6" component="div">CPR</Typography>
                              <Typography className="fs-6" variant="h4" component="h6">5</Typography>
                            </Stack>
                          </Grid>
                          <Grid item xs={6} xl={6} lg={6} md={6} sm={6}>
                            <Stack
                              mb={0.5}
                              flex={'flex'}
                              alignItems={'center'}
                              justifyContent={'space-between'}
                              flexDirection={'row'}
                              sx={{
                                display: 'flex'
                              }}
                            >
                              <Typography className="fs-6" component="div">Views</Typography>
                              <Typography className="fs-6" variant="h4" component="h6">500K</Typography>
                            </Stack>
                            <Stack
                              flex={'flex'}
                              alignItems={'center'}
                              justifyContent={'space-between'}
                              flexDirection={'row'}
                              sx={{
                                display: 'flex'
                              }}
                            >
                              <Typography className="fs-6" component="div">Total Posts</Typography>
                              <Typography className="fs-6" variant="h4" component="h6">5</Typography>
                            </Stack>
                          </Grid>
                        </Grid>
                      </Card>
                    </div>
                  </Carousel>}
                </div>
              </div>
            </div>
          </Box>
        </Stack><CommonModel
            open={getUserType() == COMPANY && !brandCount ? modelOpen : false}
            handleDialogClose={() => dispatch(updateUser({ modelOpen: false }))}
            dialogTitle={""}
            dialogPara={`No brands are linked to your company yet. Please create at least one brand to continue.`}
            nvCancel={""}
            yesHandle={() => {
              dispatch(updateUser({ modelOpen: false }));
            }} /><CommonModel
            open={modelNewOpen}
            handleDialogClose={() => setModelOpen(false)}
            dialogTitle={""}
            dialogPara={`This company is not affiliated with any brands.`}
            nvCancel={""}
            yesHandle={() => {
              setModelOpen(false);
            }} /></>
      )}
    </>
  );
};
export default React.memo(Dashboard);
const SearchInfluencerDiv = ({ navigate,isScreenZoomed }) => {
  return (
    <Grid item xs={12}>
      <Box sx={{
        boxShadow: '0px 0px 24px 0px rgba(0, 0, 0, 0.10)', borderRadius: '10px',
        height: '184px',
        width: '100%', background: `url(${discoverBg})`, objectFit: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'right', padding: '16px'
      }}>
        <Stack direction="column" justifyContent="space-between" height={"100%"} width={"35%"}>
          <Typography fontSize={isScreenZoomed ? 18 : 24} fontFamily={"var(--family1)"} fontWeight={700} textTransform="uppercase" color={"#000000"}>Click here to find <br /> influencers</Typography>
          <Button onClick={() => navigate('/discover-influencers')} sx={{ background: 'linear-gradient(125deg,rgba(255, 204, 112, 1) 0%, rgba(200, 80, 192, 1) 50%, rgba(65, 88, 208, 1) 100%)', padding: '0', borderRadius: '10px', margin: '0px', width: 'fit-content' }}><Typography sx={{ color: 'white', margin: '2px', borderRadius: '9px', padding: { xs: '10px', sm: '12px 24px' }, width: 'fit-content', height: '100%', fontSize: "16px", background: 'transparent', display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 600, "&:hover": { background: 'transparent', color: 'white' } }}>Search Influencers
          </Typography></Button>
        </Stack>
      </Box>
    </Grid>
  )
}
const MyCampaignListingDiv = ({ navigate, myCampaigns, order, sort_key, EnhancedTableHead,isScreenZoomed }) => {
  return (
    <Grid item xs={12}>
      <Box sx={{
        boxShadow: '0px 0px 24px 0px rgba(0, 0, 0, 0.10)', borderRadius: '10px',
        height: '420px',
        width: '100%'
      }}>
        <Stack direction={"row"} justifyContent="space-between" alignItems="center" sx={{ padding: '16px' }}>
          <Typography fontSize={16} fontWeight={500} color={"#000000"}>Campaigns</Typography>
          <Link style={{ textDecoration: 'none' }} to={"/my-campaigns"}>
            <Typography fontSize={16} fontWeight={400} color={"var(--color-blue)"} sx={{ textDecoration: 'none' }}>See All</Typography>
          </Link>
        </Stack>
        {myCampaigns && myCampaigns?.length ? <TableContainer stickyHeader>
          <Table stickyHeader aria-label="sticky table">
            <EnhancedTableHead
              order={order}
              orderBy={sort_key}
              onRequestSort={() => { }}
              numSelected={0}
              onSelectAllClick={function () {
                throw new Error("Function not implemented.");
              }} />
            <TableBody>
              {(
                myCampaigns?.map((row) => {
                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={row?.id}
                      className={"tableRow"}
                      sx={{
                        "&:hover": {
                          backgroundColor: '#F0F7FF !important', "& td": {
                            backgroundColor: "inherit !important"
                          },
                        }, height: '60px'
                      }}>
                      <TableCell component="td" scope="row" padding="none">
                        <Link className="text-decoration-none" style={{ fontSize: '14px', fontWeight: '500', letterSpacing: '0px', textTransform: 'capitalize' }} onClick={(e) => {
                          e.preventDefault();
                          navigate(`/campaign/partial/details/${row.id}`, { state: row });
                        }}>{trunCateString(row?.name, 15) || "N/A"}</Link>
                      </TableCell>
                      <TableCell component="td" scope="row" padding="none" sx={{ textTransform: "uppercase" }}>
                        {trunCateString(row?.brandName, isScreenZoomed ? 15 : 10) || "N/A"}
                      </TableCell>
                      <TableCell component="td" scope="row" padding="none" className='capitalize-first-letter'>
                        {row?.type || "N/A"}
                      </TableCell>
                      <TableCell component="td" scope="row" padding="none">
                        {moment(row?.startDate).format("DD MMM")}{" - "}{moment(row?.endDate).format("DD MMM")}
                      </TableCell>
                      <TableCell align="left">
                        <button className={row.status?.toLowerCase() + " capitalize-first-letter"}>{row.status}</button>
                      </TableCell>
                      <TableCell>
                        <Stack direction={"row"} style={{ gap: '8px' }}>
                          <span className='viewIcon' onClick={() => navigate(`/campaign/partial/details/${row.id}`, { state: { type: row.type } })}>View</span>
                        </Stack>
                      </TableCell>
                    </TableRow>
                  );
                })
              )}
            </TableBody>
          </Table>
        </TableContainer> : (
          <>
            <Stack sx={{ height: '85%', width: '100%', border: '0px solid red' }} direction="column" justifyContent="center" alignItems="center">
              <img src={Rocket} alt="Rocket" style={{ height: '56px', width: '56px', border: '0px solid', marginBottom: '24px' }} />
              <Stack direction="column" gap={0.2} justifyContent="center" alignItems="center">
                <Typography fontSize={20} fontWeight={400} color="black">(0) Campaign</Typography>
                <Typography fontSize={14} fontWeight={400} color="#726C6C">There is no campaign, start  creating campaign</Typography>
              </Stack>
              <Link to={"/campaign/type"}>
                <Button
                  sx={{
                    marginTop: '24px', borderRadius: '10px', position: 'relative', background: 'linear-gradient(90deg,rgba(255, 204, 112, 1) 0%, rgba(200, 80, 192, 1) 50%, rgba(65, 88, 208, 1) 100%)', padding: '2px', overflow: 'hidden', width: '100%'
                  }}
                >
                  <Typography sx={{
                    width: '340px', padding: '10px 20px', background: 'white', borderRadius: '8px', color: '#000000', fontWeight: '500', fontSize: '16px', height: '43px', "&:hover": {
                      background: 'transparent', color: 'white', "img": {
                        filter: 'brightness(100)', mixBlendMode: 'screen'
                      }
                    }
                  }}>
                    Create New Campaign <img src={arrow} alt="" style={{ width: '20px', height: '20px', rotate: '180deg' }} />
                  </Typography>
                </Button>
              </Link>
            </Stack>
          </>
        )}
      </Box>
    </Grid>
  )
}